/* Separate native digital purchase, bound once per product section. */
(() => {
  if (window.__ccfStlMakeoverLoaded) return;
  window.__ccfStlMakeoverLoaded = true;
  function init() {
  /* ── Hide the "Type" option selector ────────────────────────────── */
  function ccfNormalizeDeliveryText(value){
    return String(value || "")
      .toLowerCase()
      .replace(/[\-_/]+/g," ")
      .replace(/:/g,"")
      .replace(/\s+/g," ")
      .trim();
  }
  function ccfIsDeliveryOptionName(value){
    var name = ccfNormalizeDeliveryText(String(value || "").split(":")[0]);
    return ["type","format","delivery","product type","purchase option","version","file type"].indexOf(name) !== -1;
  }
  function ccfIsPhysicalDeliveryValue(value){
    var text = ccfNormalizeDeliveryText(value);
    return ["physical","physical product","cookie cutter","printed cutter","printed product","default title"].indexOf(text) !== -1;
  }
  function ccfIsDigitalDeliveryValue(value){
    var text = ccfNormalizeDeliveryText(value);
    return ["stl","stl file","stl download","digital stl","digital stl download","digital download","download file","home printing"].indexOf(text) !== -1;
  }

  /* ── Hide raw delivery/type selector; STL uses this dedicated block ── */
  function ccfHideTypeSelector(){
    var labels = document.querySelectorAll("legend, label, .form__label");
    for(var i=0;i<labels.length;i++){
      var el = labels[i];
      if(!ccfIsDeliveryOptionName(el.textContent || "")) continue;
      var wrapper = el.closest("fieldset") || el.closest(".product-form__input") || el.parentElement;
      if(!wrapper) continue;

      var values = [];
      wrapper.querySelectorAll("input[type=radio], option").forEach(function(input){
        values.push(input.value || input.textContent || "");
      });
      var hasPhysical = values.some(ccfIsPhysicalDeliveryValue);
      var hasDigital = values.some(ccfIsDigitalDeliveryValue);
      if(!hasPhysical || !hasDigital) continue;

      wrapper.style.display = "none";
      wrapper.setAttribute("hidden", "hidden");
      wrapper.setAttribute("aria-hidden", "true");

      var radios = wrapper.querySelectorAll("input[type=radio]");
      for(var j=0;j<radios.length;j++){
        if(ccfIsPhysicalDeliveryValue(radios[j].value)){
          if(!radios[j].checked){
            radios[j].checked = true;
            radios[j].dispatchEvent(new Event("change",{bubbles:true}));
          }
          break;
        }
      }

      var selects = wrapper.querySelectorAll("select");
      for(var s=0;s<selects.length;s++){
        for(var o=0;o<selects[s].options.length;o++){
          if(ccfIsPhysicalDeliveryValue(selects[s].options[o].value)){
            if(selects[s].selectedIndex !== o){
              selects[s].selectedIndex = o;
              selects[s].dispatchEvent(new Event("change",{bubbles:true}));
            }
            break;
          }
        }
      }
    }
  }
  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", ccfHideTypeSelector);
  } else { ccfHideTypeSelector(); }
  setTimeout(ccfHideTypeSelector, 500);
  setTimeout(ccfHideTypeSelector, 1500);

  /* ── Banner toggle ──────────────────────────────────────────────── */
  var banner = document.getElementById("ccfStlBanner");
  var section = document.getElementById("ccfStlSection");
  if(!banner || !section || section.dataset.makeoverConnected === 'true') return;
  section.dataset.makeoverConnected = 'true';

  banner.addEventListener("click", function(){
    var open = section.classList.toggle("visible");
    banner.classList.toggle("open", open);
    banner.setAttribute("aria-expanded", open ? "true" : "false");
  });
  /* ── Multi-size: pill selection → reveal purchase row ───────────── */
  var pills = document.querySelectorAll(".ccf-stl-pill");
  var purchaseRow = document.getElementById("ccfStlPurchase");
  var sizeLabel = document.getElementById("ccfStlSelectedSize");
  var priceLabel = document.getElementById("ccfStlSelectedPrice");
  var addBtn = document.getElementById("ccfStlAddBtn");
  var selectedVid = null;
  var ccfStlBusy = false;

  pills.forEach(function(pill){
    pill.addEventListener("click", function(){
      if (pill.disabled || pill.getAttribute('data-available') !== 'true' || ccfStlBusy) return;
      /* De-select all pills, highlight this one */
      pills.forEach(function(p){ p.classList.remove("active"); p.setAttribute("aria-pressed", "false"); });
      pill.classList.add("active");
      pill.setAttribute("aria-pressed", "true");

      /* Populate the purchase row */
      selectedVid = parseInt(pill.getAttribute("data-variant-id"));
      if(sizeLabel) sizeLabel.textContent = pill.getAttribute("data-size-label");
      if(priceLabel) {
        var digitalPrice = document.createElement('span');
        digitalPrice.className = 'price';
        digitalPrice.setAttribute('data-ccf-campaign-cents', pill.getAttribute('data-price-cents'));
        digitalPrice.setAttribute('data-ccf-campaign-currency', section.dataset.currency);
        var regular = document.createElement('span'); regular.className = 'price__regular';
        var amount = document.createElement('span'); amount.className = 'price-item--regular'; amount.textContent = pill.getAttribute('data-price');
        regular.appendChild(amount); digitalPrice.appendChild(regular); priceLabel.replaceChildren(digitalPrice);
      }

      /* Show the purchase row */
      if(purchaseRow){
        purchaseRow.classList.add("visible");
        /* Reset button state in case a previous add was done */
        if(addBtn){
          addBtn.disabled = !ccfStlAcked();
          addBtn.textContent = "Add STL to cart";
          addBtn.style.background = "";
        }
      }
    });
  });

  /* ── Add to Cart handler (works for both multi-size and single) ── */
  function ccfStlAcked(){ var a = document.getElementById("ccfStlAckBox"); return !!a && a.checked; }
  function ccfStlAvailable(vid){
    return Array.from(document.querySelectorAll('.ccf-stl-pill[data-variant-id], .ccf-stl-single-row .ccf-stl-row-btn[data-variant-id]')).some(function(node){ return Number(node.getAttribute('data-variant-id')) === Number(vid) && node.getAttribute('data-available') === 'true'; });
  }
  function ccfSyncStlAck(){
    var ok = ccfStlAcked();
    document.querySelectorAll(".ccf-stl-row-btn").forEach(function(b){ b.disabled = ccfStlBusy || !ok || !ccfStlAvailable(b === addBtn ? selectedVid : b.getAttribute('data-variant-id')); });
  }
  var ackBox = document.getElementById("ccfStlAckBox");
  if(ackBox){ ackBox.addEventListener("change", ccfSyncStlAck); ccfSyncStlAck(); }
  function ccfAddToCart(btn, vid){
    if (ccfStlBusy || !Number.isSafeInteger(vid) || !ccfStlAvailable(vid)) return;
    if(!ccfStlAcked()){
      var box = document.getElementById("ccfStlAck");
      if(box){ box.classList.add("ccf-stl-ack--nudge"); setTimeout(function(){ box.classList.remove("ccf-stl-ack--nudge"); }, 900); }
      if(ackBox) ackBox.focus();
      return;
    }
    ccfStlBusy = true;
    ccfSyncStlAck();
    var errorNode = document.getElementById('ccfStlError');
    if (errorNode) { errorNode.hidden = true; errorNode.textContent = ''; }
    var statusNode = document.getElementById('ccfStlStatus');
    if (statusNode) { statusNode.hidden = true; statusNode.textContent = ''; }
    var orig = btn.innerHTML;
    btn.textContent = "Adding\u2026";
    var nativeCart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var payload = {id: vid, quantity: 1};
    if (nativeCart) {
      payload.sections = nativeCart.getSectionsToRender().map(function(item){ return item.id; });
      payload.sections_url = window.location.pathname;
      nativeCart.setActiveElement(btn);
    }
    var ajaxAddUrl = window.routes ? window.routes.cart_add_url : '/cart/add.js';
    if (!ajaxAddUrl.endsWith('.js')) ajaxAddUrl += '.js';
    fetch(ajaxAddUrl, {
      method: "POST",
      headers: {"Content-Type":"application/json", "Accept":"application/json", "X-Requested-With":"XMLHttpRequest"},
      body: JSON.stringify(payload)
    })
    .then(function(r){ return r.json().then(function(data){ if (!r.ok || data.status) throw new Error(data.description || data.message || 'Could not add this file. Please try again.'); return data; }); })
    .then(function(data){
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'ccf-stl-download', productVariantId: vid, cartData: data});
      if (nativeCart) { nativeCart.classList.remove('is-empty'); nativeCart.renderContents(data); }
      else { window.location.assign(window.routes ? window.routes.cart_url : '/cart'); }
      btn.innerHTML = orig;
      if (statusNode) { statusNode.textContent = 'STL file added to cart.'; statusNode.hidden = false; }
    })
    .catch(function(error){
      btn.innerHTML = orig;
      if (errorNode) { errorNode.textContent = error.message || 'Could not add to cart. Please try again.'; errorNode.hidden = false; }
    })
    .finally(function(){ ccfStlBusy = false; ccfSyncStlAck(); });
  }

  /* Multi-size Add to Cart */
  if(addBtn){
    addBtn.addEventListener("click", function(){
      if(selectedVid) ccfAddToCart(addBtn, selectedVid);
    });
  }

  /* Single-size Add to Cart */
  var singleBtns = document.querySelectorAll(".ccf-stl-single-row .ccf-stl-row-btn");
  singleBtns.forEach(function(btn){
    btn.addEventListener("click", function(){
      var vid = parseInt(btn.getAttribute("data-variant-id"));
      ccfAddToCart(btn, vid);
    });
  });

  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true}); else init();
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(() => { if (document.querySelector('#ccfStlSection:not([data-makeover-connected])')) init(); }).observe(document.body, {childList: true, subtree: true});
})();
